import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as VmsState from '../../backend/index-vms-state.js';
import * as Cognito from '../../backend/cognito.js';

const wizardBaseUrl = 'https://ondisplay-wizard.locuslabs.com';
const allowedMessageOrigin = new URL(wizardBaseUrl).origin

class MODWizard extends Component {
    state = { accessToken: null };

    componentDidMount = () => {
        Cognito.accessToken().then(token => this.setState(state => ({ ...state, accessToken: token })));
        window.addEventListener('message', e => {
            if (e.origin !== allowedMessageOrigin) return;
            if (e.data.name === 'plugin/confirmMenuChange') {
                const { dispatch } = this.props;
                dispatch(VmsState.ViewReducer.Actions.confirmMenuChange(e.data.wasConfirmed));
            } else if (e.data.name === 'plugin/requestNewAuthToken') {
                Cognito.accessToken().then(token => {
                    this.sendEvent('plugin/newAuthToken', { token });
                });
            }
        });
    };

    componentDidUpdate(nextProps) {
        const { showConfirmLeaveMessage } = this.props;
        if (nextProps.showConfirmLeaveMessage !== showConfirmLeaveMessage && showConfirmLeaveMessage) {
            this.sendEvent('plugin/askToConfirmLeave');
        }
    }

    sendEvent = (name, params = {}) => this.getDocument().contentWindow.postMessage({ name, params }, allowedMessageOrigin);

    getDocument = () => document.getElementById('mod-wizard-frame');

    render() {
        return this.state.accessToken ? (
            <iframe
                title="Maps On Digital Display Wizard"
                id="mod-wizard-frame"
                src={`${wizardBaseUrl}/?auth=${this.state.accessToken}&accountId=${this.props.accountId}`}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        ) : null;
    }
}

const mapStateToProps = state => {
    const menuItemToBeConfirmed = VmsState.ViewReducer.Selectors.getMenuItemToBeConfirmed(state) || null;
    const showConfirmLeaveMessage = menuItemToBeConfirmed !== null;
    const accountId = VmsState.SessionReducer.Selectors.getAccountId(state);

    return { showConfirmLeaveMessage, accountId };
};

export default connect(mapStateToProps)(MODWizard);
